// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================ */
/* NOTIFICATIONS & MESSAGING STYLES */
/* ============================================ */

/* ==================== NOTIFICATION BELL ==================== */
.notification-bell-container,
.message-bell-container {
  position: relative;
  display: inline-block;
}

.notification-bell-button,
.message-bell-button {
  position: relative;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.notification-bell-button:hover,
.message-bell-button:hover {
  background: var(--bg-gray);
}

.bell-icon,
.message-icon {
  font-size: 1.5rem;
  display: block;
}

.notification-badge,
.message-badge {
  position: absolute;
  top: 2px;
  right: 2px;
  background: var(--primary-red);
  color: var(--text-white);
  border-radius: 10px;
  padding: 2px 6px;
  font-size: 0.65rem;
  font-weight: 700;
  min-width: 18px;
  text-align: center;
  box-shadow: var(--shadow-red);
  animation: pulse 2s ease infinite;
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

/* Notification Dropdown */
.notification-dropdown {
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  width: 380px;
  max-width: 90vw;
  background: var(--bg-card);
  border: 1px solid var(--border-gray);
  border-radius: 12px;
  box-shadow: var(--shadow-dark), 0 0 20px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  animation: slideDown 0.2s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.notification-dropdown-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid var(--border-gray);
}

.notification-dropdown-header h3 {
  margin: 0;
  font-size: 1.1rem;
  color: var(--text-white);
  font-weight: 600;
}

.mark-all-read-btn {
  background: transparent;
  border: 1px solid var(--primary-red);
  color: var(--primary-red);
  padding: 0.4rem 0.8rem;
  border-radius: 6px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
}

.mark-all-read-btn:hover {
  background: var(--primary-red);
  color: var(--text-white);
}

.notification-list {
  max-height: 400px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: var(--border-gray) var(--bg-gray);
}

.notification-list::-webkit-scrollbar {
  width: 6px;
}

.notification-list::-webkit-scrollbar-track {
  background: var(--bg-gray);
}

.notification-list::-webkit-scrollbar-thumb {
  background: var(--border-gray);
  border-radius: 3px;
}

.notification-item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--border-gray);
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

.notification-item:last-child {
  border-bottom: none;
}

.notification-item:hover {
  background: var(--bg-gray);
}

.notification-item.unread {
  background: var(--bg-gray-light);
  border-left: 3px solid var(--primary-red);
}

.notification-item--action-required {
  border-left: 3px solid #f59e0b;
  background: rgba(245, 158, 11, 0.07);
}

.notification-item--action-required.unread {
  border-left: 3px solid #f59e0b;
}

.notification-dropdown-action-badge {
  display: inline-block;
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #fbbf24;
  margin-bottom: 0.25rem;
}

.notification-icon {
  font-size: 1.5rem;
  flex-shrink: 0;
  margin-top: 0.2rem;
}

.notification-content {
  flex: 1;
  min-width: 0;
}

.notification-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-white);
  margin-bottom: 0.25rem;
}

.notification-message {
  font-size: 0.85rem;
  color: var(--text-gray);
  line-height: 1.4;
  margin-bottom: 0.25rem;
}

.notification-time {
  font-size: 0.75rem;
  color: var(--text-muted);
}

.unread-indicator {
  width: 8px;
  height: 8px;
  background: var(--primary-red);
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 0.5rem;
  box-shadow: var(--shadow-red);
}

.no-notifications {
  padding: 3rem 2rem;
  text-align: center;
}

.no-notif-icon {
  font-size: 3rem;
  display: block;
  margin-bottom: 1rem;
  opacity: 0.5;
}

.no-notifications p {
  color: var(--text-gray);
  font-size: 0.9rem;
}

.notification-dropdown-footer {
  padding: 0.75rem 1rem;
  border-top: 1px solid var(--border-gray);
  text-align: center;
}

.view-all-btn {
  background: transparent;
  border: none;
  color: var(--primary-red);
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.view-all-btn:hover {
  background: var(--bg-gray);
}

/* ==================== NOTIFICATIONS PAGE ==================== */
.notifications-page {
  padding: 2rem;
  max-width: 900px;
  margin: 0 auto;
}

.notifications-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.notifications-header h1 {
  color: var(--text-white);
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.notifications-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: center;
}

.clear-all-btn {
  border-color: var(--text-muted);
  color: var(--text-gray);
}

.clear-all-btn:hover {
  border-color: var(--text-white);
  color: var(--text-white);
}

.notifications-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 2rem;
  border-bottom: 2px solid var(--border-gray);
  padding-bottom: 0.5rem;
}

.filter-btn {
  background: transparent;
  border: none;
  color: var(--text-gray);
  padding: 0.75rem 1rem;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 3px solid transparent;
  margin-bottom: -0.5rem;
  white-space: nowrap;
}

.filter-btn:hover {
  color: var(--text-white);
}

.filter-btn.active {
  color: var(--text-white);
  border-bottom-color: var(--primary-red);
}

.notifications-content {
  min-height: 400px;
}

.notifications-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
}

.no-notifications-page {
  text-align: center;
  padding: 4rem 2rem;
}

.no-notifications-page .no-notif-icon {
  font-size: 4rem;
  margin-bottom: 1.5rem;
}

.no-notifications-page h2 {
  color: var(--text-white);
  margin-bottom: 1rem;
  font-size: 1.5rem;
}

.no-notifications-page p {
  color: var(--text-gray);
  max-width: 500px;
  margin: 0 auto;
  line-height: 1.6;
}

.notifications-list-page {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.notification-card {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  background: var(--bg-card);
  border: 1px solid var(--border-gray);
  border-radius: 12px;
  padding: 1.5rem;
  transition: all 0.3s ease;
  position: relative;
}

.notification-card.unread {
  border-left: 4px solid var(--primary-red);
  background: var(--bg-gray-light);
}

.notification-card--action-required {
  border-left: 4px solid #f59e0b;
  border-color: rgba(245, 158, 11, 0.4);
  background: rgba(245, 158, 11, 0.06);
}

.notification-card--action-required.unread {
  border-left: 4px solid #f59e0b;
}

.notification-action-required-badge {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #fbbf24;
  background: rgba(245, 158, 11, 0.15);
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  margin-bottom: 0.5rem;
}

.notification-stale-panel {
  padding: 0.5rem 0 1rem;
}

.notification-stale-title {
  margin: 0 0 0.75rem;
  font-size: 1.15rem;
  color: var(--text-white);
}

.notification-stale-body {
  margin: 0;
  color: var(--text-gray);
  line-height: 1.55;
}

.notification-stale-actions {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-top: 1.25rem;
}

.notification-card:hover {
  border-color: var(--border-red);
  box-shadow: var(--shadow-red);
  transform: translateX(5px);
}

.notification-card-icon {
  font-size: 2rem;
  flex-shrink: 0;
}

.notification-card-content {
  flex: 1;
  min-width: 0;
  cursor: pointer;
}

.notification-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 0.5rem;
}

.notification-card-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--text-white);
  margin: 0;
}

.notification-card-time {
  font-size: 0.85rem;
  color: var(--text-muted);
  white-space: nowrap;
  flex-shrink: 0;
}

.notification-card-message {
  color: var(--text-gray);
  line-height: 1.6;
  margin: 0 0 0.5rem 0;
}

.notification-card-sender {
  color: var(--text-muted);
  font-size: 0.9rem;
  margin: 0;
  font-style: italic;
}

.notification-card-actions {
  display: flex;
  gap: 0.5rem;
  flex-shrink: 0;
}

.notification-action-btn {
  background: var(--bg-gray);
  border: 1px solid var(--border-gray);
  color: var(--text-white);
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1.2rem;
}

.notification-action-btn:hover {
  background: var(--primary-red);
  border-color: var(--primary-red);
}

.notification-action-btn.delete:hover {
  background: #ef4444;
  border-color: #ef4444;
}

/* Artist left bar: formatted intro + show list */
.notification-artist-left-bar-intro {
  margin: 0 0 0.5rem 0;
  color: var(--text-gray);
  line-height: 1.5;
  font-size: inherit;
}

.notification-artist-left-bar-list {
  max-height: 180px;
  overflow-y: auto;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  padding: 0.4rem;
  margin-top: 0.35rem;
  background: rgba(0, 0, 0, 0.2);
}

.notification-artist-left-bar-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.25rem;
  padding: 0.5rem 0.6rem;
  border-radius: 6px;
  margin-bottom: 0.2rem;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.9);
}

.notification-artist-left-bar-item:last-child {
  margin-bottom: 0;
}

.notification-artist-left-bar-item:hover {
  background: rgba(255, 255, 255, 0.06);
}

.notification-artist-left-bar-item strong {
  font-weight: 600;
  color: var(--text-white, #fff);
}

.notification-artist-left-bar-time {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.7);
}

/* Dropdown: slightly smaller list for compact view */
.notification-message .notification-artist-left-bar-list {
  max-height: 120px;
}

/* ==================== MESSAGES PAGE ==================== */
/* Wrapper to isolate messages page styling from other pages */
.messages-page-wrapper {
  position: fixed;
  top: 0;
  left: 280px;
  right: 0;
  bottom: 0;
  overflow: hidden;
}

@media (max-width: 768px) {
  .messages-page-wrapper {
    left: 0;
    top: 64px;
    bottom: 0;
  }
}

.messages-page {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding-top: 0.5rem; /* prevent header from being clipped at top */
}

.messages-container {
  display: flex;
  flex: 1;
  min-height: 0;
  background: var(--bg-dark);
  overflow: hidden;
}

.messages-sidebar {
  width: 350px;
  border-right: 1px solid var(--border-gray);
  display: flex;
  flex-direction: column;
  background: var(--bg-card);
  min-width: 0;
  overflow: hidden;
}

.messages-sidebar-header {
  padding: 1.5rem;
  border-bottom: 1px solid var(--border-gray);
}

.messages-sidebar-header h2 {
  margin: 0;
  color: var(--text-white);
  font-size: 1.5rem;
  font-weight: 700;
}

.conversation-list {
  flex: 1;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: var(--border-gray) var(--bg-gray);
}

.conversation-list::-webkit-scrollbar {
  width: 6px;
}

.conversation-list::-webkit-scrollbar-track {
  background: var(--bg-gray);
}

.conversation-list::-webkit-scrollbar-thumb {
  background: var(--border-gray);
  border-radius: 3px;
}

.conversation-list-loading,
.no-conversations {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  text-align: center;
}

.no-conv-icon {
  font-size: 3rem;
  display: block;
  margin-bottom: 1rem;
  opacity: 0.5;
}

.no-conversations h3 {
  color: var(--text-white);
  margin-bottom: 0.5rem;
}

.no-conversations p {
  color: var(--text-gray);
  font-size: 0.9rem;
}

.conversation-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid var(--border-gray);
  cursor: pointer;
  transition: all 0.2s ease;
}

.conversation-item:hover {
  background: var(--bg-gray);
}

.conversation-item.selected {
  background: var(--bg-gray-light);
  border-left: 3px solid var(--primary-red);
}

.conversation-item.unread {
  background: var(--bg-gray-light);
}

.conversation-item.pinned {
  border-left: 2px solid var(--primary-red);
}

.conversation-item.dragging {
  opacity: 0.6;
  background: var(--bg-gray);
}

.conversation-drag-handle {
  cursor: grab;
  padding: 0.25rem 0.5rem;
  margin-right: 0.25rem;
  color: var(--text-secondary);
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  opacity: 0.6;
  border-radius: 4px;
}

.conversation-drag-handle:hover {
  opacity: 1;
  background: var(--bg-gray);
}

.conversation-drag-handle:active {
  cursor: grabbing;
}

.conversation-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--primary-red);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-white);
  font-weight: 700;
  font-size: 1.2rem;
  flex-shrink: 0;
}

.group-avatar-icon {
  width: 24px;
  height: 24px;
  color: #ffffff;
}

.conversation-details {
  flex: 1;
  min-width: 0;
}

.conversation-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.25rem;
}

.conversation-header-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.conversation-pin-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  font-size: 0.9rem;
  opacity: 0.5;
  transition: opacity 0.2s ease;
}

.conversation-pin-btn:hover {
  opacity: 0.9;
}

.conversation-pin-btn.pinned {
  opacity: 1;
}

.conversation-name {
  font-weight: 600;
  color: var(--text-white);
  font-size: 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.conversation-time {
  font-size: 0.75rem;
  color: var(--text-muted);
  white-space: nowrap;
  flex-shrink: 0;
  margin-left: 0.5rem;
}

.conversation-message-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
}

.conversation-last-message {
  font-size: 0.85rem;
  color: var(--text-gray);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}

.conversation-unread-badge {
  background: var(--primary-red);
  color: var(--text-white);
  border-radius: 10px;
  padding: 2px 8px;
  font-size: 0.75rem;
  font-weight: 700;
  min-width: 20px;
  text-align: center;
  flex-shrink: 0;
}

/* Messages Main */
.messages-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: var(--bg-dark);
  min-width: 0;
  overflow: hidden;
}

.chat-window-empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty-state {
  text-align: center;
  padding: 2rem;
}

.empty-icon {
  font-size: 4rem;
  display: block;
  margin-bottom: 1rem;
  opacity: 0.3;
}

.empty-state h2 {
  color: var(--text-white);
  margin-bottom: 0.5rem;
}

.empty-state p {
  color: var(--text-gray);
}

/* Chat Window */
.chat-window {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid var(--border-gray);
  background: var(--bg-card);
}

.chat-back-btn {
  flex-shrink: 0;
  border: 1px solid var(--border-gray);
  background: var(--bg-dark);
  color: var(--text-white);
  padding: 0.45rem 0.75rem;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;
}

.chat-back-btn:hover {
  background: var(--bg-gray);
  border-color: var(--primary-red);
  color: var(--primary-red);
}

.chat-header-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.chat-archive-btn {
  border: 1px solid var(--border-gray);
  background: var(--bg-dark);
  color: var(--text-white);
  min-width: 36px;
  height: 36px;
  padding: 0 0.6rem;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 600;
}

.chat-archive-btn:hover {
  background: var(--border-gray);
}

.chat-archive-btn:active {
  transform: translateY(1px);
}

.chat-header-info {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 1;
  min-width: 0;
}

.chat-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--primary-red);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-white);
  font-weight: 700;
  font-size: 1.1rem;
}

.chat-name {
  color: var(--text-white);
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
}

.chat-name-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.chat-title-edit-btn {
  border: none;
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
  font-size: 0.9rem;
  padding: 0.2rem;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.chat-title-edit-btn:hover {
  color: var(--text-white);
  background: var(--bg-gray);
}

.chat-name-edit-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.chat-name-input {
  min-width: 220px;
  max-width: 360px;
  padding: 0.4rem 0.6rem;
  border-radius: 8px;
  border: 1px solid var(--border-gray);
  background: var(--bg-gray);
  color: var(--text-white);
  font-size: 0.95rem;
}

.chat-name-input:focus {
  outline: none;
  border-color: var(--primary-red);
}

.chat-title-action-btn {
  border: 1px solid var(--primary-red);
  background: var(--primary-red);
  color: var(--text-white);
  border-radius: 8px;
  height: 32px;
  padding: 0 0.65rem;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.8rem;
}

.chat-title-action-btn.secondary {
  background: transparent;
  border-color: var(--border-gray);
  color: var(--text-gray);
}

.chat-group-members {
  font-size: 0.8rem;
  color: var(--text-secondary);
  opacity: 0.85;
  margin-top: 0.15rem;
  line-height: 1.3;
}

.typing-indicator-text {
  color: var(--primary-red);
  font-size: 0.85rem;
  font-style: italic;
}

.chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  scrollbar-width: thin;
  scrollbar-color: var(--border-gray) var(--bg-gray);
}

.chat-messages-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  gap: 1rem;
  padding: 2rem;
}

.chat-messages-loading .spinner {
  width: 40px;
  height: 40px;
  border: 4px solid var(--border-gray);
  border-top: 4px solid var(--primary-red);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.chat-messages-loading p {
  color: var(--text-secondary);
  font-size: 0.9rem;
  margin: 0;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.chat-messages::-webkit-scrollbar {
  width: 8px;
}

.chat-messages::-webkit-scrollbar-track {
  background: var(--bg-gray);
}

.chat-messages::-webkit-scrollbar-thumb {
  background: var(--border-gray);
  border-radius: 4px;
}

.no-messages {
  text-align: center;
  padding: 2rem;
  color: var(--text-gray);
}

/* Message Bubbles */
.message-bubble-container {
  display: flex;
  flex-direction: column;
  max-width: 70%;
}

.message-bubble-container.own {
  align-self: flex-end;
  align-items: flex-end;
}

.message-bubble-container.other {
  align-self: flex-start;
  align-items: flex-start;
}

.message-sender-name {
  font-size: 0.8rem;
  color: var(--text-muted);
  margin-bottom: 0.25rem;
  padding: 0 0.5rem;
}

.message-bubble {
  padding: 0.75rem 1rem;
  border-radius: 16px;
  word-wrap: break-word;
  animation: messageSlideIn 0.2s ease;
}

@keyframes messageSlideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.message-bubble-container.own .message-bubble {
  background: var(--primary-red);
  color: var(--text-white);
  border-bottom-right-radius: 4px;
}

.message-bubble-container.other .message-bubble {
  background: var(--bg-gray);
  color: var(--text-white);
  border-bottom-left-radius: 4px;
}

.message-text {
  font-size: 0.95rem;
  line-height: 1.5;
  margin-bottom: 0.25rem;
}

.message-edited {
  font-size: 0.75rem;
  opacity: 0.7;
  font-style: italic;
}

.message-time {
  font-size: 0.75rem;
  opacity: 0.7;
  text-align: right;
}

/* Chat Input */
.chat-input-container {
  display: flex;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid var(--border-gray);
  background: var(--bg-card);
}

.chat-input {
  flex: 1;
  padding: 0.75rem 1rem;
  background: var(--bg-gray);
  border: 2px solid var(--border-gray);
  border-radius: 24px;
  color: var(--text-white);
  font-size: 0.95rem;
  resize: none;
  max-height: 120px;
  font-family: inherit;
  transition: all 0.3s ease;
}

.chat-input:focus {
  outline: none;
  border-color: var(--primary-red);
  background: var(--bg-gray-light);
}

.chat-input::placeholder {
  color: var(--text-muted);
}

.chat-send-btn {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--primary-red);
  border: none;
  color: var(--text-white);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.chat-send-btn:hover:not(:disabled) {
  background: var(--primary-red-dark);
  transform: scale(1.05);
  box-shadow: var(--shadow-red);
}

.chat-send-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.send-icon {
  font-size: 1.2rem;
  display: block;
}

/* Responsive Styles */
@media (max-width: 768px) {
  /* Mobile Header Updates */
  .mobile-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .mobile-header-left {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .mobile-header-right {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .messages-container {
    position: relative;
  }

  /* Inbox: full-width conversation list only */
  .messages-container--mobile-inbox .messages-sidebar {
    position: relative;
    width: 100%;
    max-width: 100%;
    flex: 1;
    min-height: 0;
    transform: none;
    border-right: none;
  }

  .messages-container--mobile-inbox .messages-main {
    display: none;
  }

  /* Thread: full-width chat only */
  .messages-container--mobile-thread .messages-sidebar {
    display: none;
  }

  .messages-container--mobile-thread .messages-main {
    display: flex;
    flex: 1;
    width: 100%;
    min-width: 0;
    min-height: 0;
    overflow: hidden;
  }

  .notification-dropdown {
    width: 340px;
  }

  .notifications-page {
    padding: 1rem;
  }

  .notifications-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .notifications-filters {
    gap: 0.35rem;
  }

  .filter-btn {
    padding: 0.6rem 0.75rem;
    font-size: 0.85rem;
  }

  .notification-card {
    padding: 1rem;
  }

  .message-bubble-container {
    max-width: 85%;
  }
}

@media (max-width: 480px) {
  /*
   * Keep the panel under the bell: width must stay bounded relative to the narrow
   * .notification-bell-container — nearly full-viewport width + right offset pinned the
   * dropdown’s right edge to the bell but stretched the sheet far left across the screen.
   */
  .notification-dropdown {
    width: min(340px, calc(100vw - 1.5rem));
    max-width: calc(100vw - 1rem);
    right: 0;
    left: auto;
  }

  .conversation-item {
    padding: 0.75rem 1rem;
  }

  .chat-header {
    padding: 0.75rem 1rem;
  }

  .chat-messages {
    padding: 1rem;
  }

  .chat-input-container {
    padding: 0.75rem 1rem;
  }

  .message-bubble-container {
    max-width: 90%;
  }
}

/* ==================== NEW MESSAGE DROPDOWN ==================== */
@keyframes newMessageDropdownIn {
  from {
    opacity: 0;
    transform: translate(-50%, -50%) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) translateY(0);
  }
}

.new-message-dropdown {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 500px;
  max-width: 90vw;
  max-height: 80vh;
  background: var(--bg-card);
  border: 1px solid var(--border-gray);
  border-radius: 12px;
  box-shadow: var(--shadow-dark), 0 0 20px rgba(0, 0, 0, 0.3);
  z-index: 2000;
  display: flex;
  flex-direction: column;
  animation: newMessageDropdownIn 0.2s ease;
}

.new-message-dropdown-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid var(--border-gray);
}

.new-message-dropdown-header h3 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--text-primary);
}

.new-message-dropdown-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.new-message-dropdown-close:hover {
  background: var(--bg-gray);
  color: var(--text-primary);
}

.new-message-dropdown-search {
  padding: 1rem;
  border-bottom: 1px solid var(--border-gray);
}

.new-message-search-input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--border-gray);
  border-radius: 8px;
  font-size: 0.95rem;
  background: var(--bg-primary);
  color: var(--text-primary);
}

.new-message-search-input:focus {
  outline: none;
  border-color: var(--primary-red);
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);
}

.new-message-dropdown-list {
  flex: 1;
  overflow-y: auto;
  max-height: calc(80vh - 150px);
  padding: 0.5rem;
}

.new-message-recipient-item {
  display: flex;
  align-items: center;
  padding: 0.75rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  gap: 0.75rem;
}

.new-message-recipient-item:hover {
  background: var(--bg-gray);
}

.recipient-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--primary-red);
  color: var(--text-white);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 1rem;
  flex-shrink: 0;
}

.recipient-info {
  flex: 1;
  min-width: 0;
}

.recipient-name-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.25rem;
}

.recipient-name {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 0.95rem;
}

.recipient-role-badge {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
}

.recipient-role-badge.owner {
  background: rgba(59, 130, 246, 0.1);
  color: #3b82f6;
}

.recipient-role-badge.admin {
  background: rgba(147, 51, 234, 0.1);
  color: #9333ea;
}

.recipient-role-badge.artist {
  background: rgba(234, 179, 8, 0.1);
  color: #eab308;
}

.recipient-source-badge {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.65rem;
  font-weight: 600;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recipient-source-badge.band-member {
  background: rgba(16, 185, 129, 0.15);
  color: #10b981;
}

.recipient-source-badge.bar-owner {
  background: rgba(59, 130, 246, 0.1);
  color: #3b82f6;
}

.recipient-source-badge.bar-admin {
  background: rgba(147, 51, 234, 0.1);
  color: #9333ea;
}

.recipient-source-badge.artist {
  background: rgba(234, 179, 8, 0.1);
  color: #eab308;
}

.new-message-selected {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--border-gray);
}

.selected-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.selected-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.5rem;
  background: var(--bg-gray);
  border-radius: 16px;
  font-size: 0.85rem;
}

.selected-chip-remove {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0 0.125rem;
  font-size: 1rem;
  line-height: 1;
  color: var(--text-secondary);
  border-radius: 4px;
}

.selected-chip-remove:hover {
  color: var(--primary-red);
}

.new-message-group-name {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--border-gray);
  border-radius: 6px;
  background: var(--bg-input);
  color: var(--text-primary);
  font-size: 0.9rem;
}

.new-message-group-name:focus {
  outline: none;
  border-color: var(--primary-red);
}

.new-message-dropdown-footer {
  padding: 1rem;
  border-top: 1px solid var(--border-gray);
}

/* Shown only on mobile — see modals-mobile.css; hidden on desktop (header × is enough). */
.new-message-cancel-btn {
  display: none;
}

.new-message-start-btn {
  width: 100%;
  padding: 0.75rem 1rem;
  background: var(--primary-red);
  color: var(--text-white);
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.new-message-start-btn:hover:not(:disabled) {
  background: var(--primary-red-dark);
}

.new-message-start-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.recipient-check {
  color: var(--primary-red);
  font-weight: bold;
  font-size: 1rem;
}

.new-message-recipient-item.selected {
  background: rgba(220, 38, 38, 0.08);
  border-left: 3px solid var(--primary-red);
}

/* ==================== BAR CONTACTS DROPDOWN ==================== */
.bar-contacts-dropdown {
  width: 350px;
  max-width: 90vw;
  max-height: 400px;
  background: var(--bg-card);
  border: 1px solid var(--border-gray);
  border-radius: 12px;
  box-shadow: var(--shadow-dark), 0 0 20px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  animation: slideDown 0.2s ease;
}

.bar-contacts-dropdown .new-message-dropdown-list {
  max-height: calc(400px - 60px);
}

.recipient-email {
  font-size: 0.85rem;
  color: var(--text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recipient-relationship {
  font-size: 0.85rem;
  color: var(--text-secondary);
  margin-top: 0.15rem;
}

.recipient-relationship .recipient-source-badge {
  font-size: 0.8rem;
}

.recipient-relationships {
  display: flex;
  flex-wrap: wrap;
  gap: 0 0.25rem;
  align-items: center;
}

.new-message-loading,
.new-message-error,
.new-message-empty {
  padding: 2rem;
  text-align: center;
  color: var(--text-secondary);
}

.new-message-retry-btn {
  margin-top: 1rem;
  padding: 0.5rem 1rem;
  background: var(--primary-red);
  color: var(--text-white);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease;
}

.new-message-retry-btn:hover {
  background: var(--primary-red-dark);
}

/* ==================== CONVERSATION LIST HEADER ==================== */
.conversation-list-header {
  padding: 1rem;
  border-bottom: 1px solid var(--border-gray);
  background: var(--bg-card);
}

.conversation-list-header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}

.conversation-list-header-top h2 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-primary);
}

.new-message-btn {
  padding: 0.5rem 1rem;
  background: var(--primary-red);
  color: var(--text-white);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.9rem;
  transition: all 0.2s ease;
}

.new-message-btn:hover {
  background: var(--primary-red-dark);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.3);
}

.conversation-list-search {
  width: 100%;
}

.conversation-search-input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--border-gray);
  border-radius: 8px;
  font-size: 0.9rem;
  background: var(--bg-primary);
  color: var(--text-primary);
}

.conversation-search-input:focus {
  outline: none;
  border-color: var(--primary-red);
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);
}

/* ==================== READ RECEIPTS ==================== */
.message-meta {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.25rem;
}

.message-read-receipt {
  position: relative;
  display: inline-flex;
  align-items: center;
}

/* iOS-style text labels: Delivered / Read */
.read-receipt-text {
  font-size: 0.75rem;
  line-height: 1;
  font-weight: 500;
}

.read-receipt-text.read-receipt-delivered {
  color: var(--text-secondary);
}

.read-receipt-text.read-receipt-read {
  color: var(--text-secondary);
}

/* Group: "Read by X of Y" */
.message-read-receipt-group .read-receipt-text {
  font-size: 0.7rem;
  color: var(--text-secondary);
}

.read-time-tooltip {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 0.5rem;
  padding: 0.5rem 0.75rem;
  background: rgba(0, 0, 0, 0.9);
  color: var(--text-white);
  border-radius: 6px;
  font-size: 0.75rem;
  white-space: nowrap;
  pointer-events: none;
  z-index: 10;
}

.read-time-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: rgba(0, 0, 0, 0.9);
}

/* ==================== MESSAGE ARTIST BUTTON ==================== */
.artist-profile-message-btn {
  border: none;
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.75);
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.35rem;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-right: 0.5rem;
}

.artist-profile-message-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  color: var(--primary-red);
}

.artist-profile-message-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./client/styles/notifications-messaging.css"],"names":[],"mappings":"AAAA,iDAAiD;AACjD,qCAAqC;AACrC,iDAAiD;;AAEjD,gEAAgE;AAChE;;EAEE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,8BAA8B;EAC9B,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE;;IAEE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,2DAA2D;EAC3D,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,2CAA2C;EAC3C,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oCAAoC;EACpC,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,iDAAiD;AACjD;EACE,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,qDAAqD;AACrD;EACE,iBAAiB;AACnB;;AAEA,4DAA4D;AAC5D,8DAA8D;AAC9D;EACE,eAAe;EACf,MAAM;EACN,WAAW;EACX,QAAQ;EACR,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,OAAO;IACP,SAAS;IACT,SAAS;EACX;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,6CAA6C;AACpE;;AAEA;EACE,aAAa;EACb,OAAO;EACP,aAAa;EACb,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,2CAA2C;EAC3C,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,4BAA4B;EAC5B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,OAAO;AACT;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,0BAA0B;EAC1B,wBAAwB;EACxB,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,wBAAwB;EACxB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,OAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,oCAAoC;EACpC,0BAA0B;EAC1B,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,OAAO;EACP,SAAS;EACT,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,wCAAwC;EACxC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,OAAO;EACP,qBAAqB;EACrB,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,0BAA0B;EAC1B;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA,6CAA6C;EAC7C;IACE,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,OAAO;IACP,aAAa;IACb,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA,iCAAiC;EACjC;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;;;;IAIE;EACF;IACE,uCAAuC;IACvC,6BAA6B;IAC7B,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,mEAAmE;AACnE;EACE;IACE,UAAU;IACV,kDAAkD;EACpD;EACA;IACE,UAAU;IACV,8CAA8C;EAChD;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,2DAA2D;EAC3D,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;EAClB,2BAA2B;EAC3B,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,wCAAwC;AAC1C;;AAEA,0FAA0F;AAC1F;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,8BAA8B;EAC9B,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA,oEAAoE;AACpE;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,2DAA2D;EAC3D,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,8BAA8B;EAC9B,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,qBAAqB;EACrB,uBAAuB;EACvB,8BAA8B;EAC9B,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA,oEAAoE;AACpE;EACE,YAAY;EACZ,qCAAqC;EACrC,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* ============================================ */\n/* NOTIFICATIONS & MESSAGING STYLES */\n/* ============================================ */\n\n/* ==================== NOTIFICATION BELL ==================== */\n.notification-bell-container,\n.message-bell-container {\n  position: relative;\n  display: inline-block;\n}\n\n.notification-bell-button,\n.message-bell-button {\n  position: relative;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.notification-bell-button:hover,\n.message-bell-button:hover {\n  background: var(--bg-gray);\n}\n\n.bell-icon,\n.message-icon {\n  font-size: 1.5rem;\n  display: block;\n}\n\n.notification-badge,\n.message-badge {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  background: var(--primary-red);\n  color: var(--text-white);\n  border-radius: 10px;\n  padding: 2px 6px;\n  font-size: 0.65rem;\n  font-weight: 700;\n  min-width: 18px;\n  text-align: center;\n  box-shadow: var(--shadow-red);\n  animation: pulse 2s ease infinite;\n}\n\n@keyframes pulse {\n  0%,\n  100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n}\n\n/* Notification Dropdown */\n.notification-dropdown {\n  position: absolute;\n  top: calc(100% + 0.5rem);\n  right: 0;\n  width: 380px;\n  max-width: 90vw;\n  background: var(--bg-card);\n  border: 1px solid var(--border-gray);\n  border-radius: 12px;\n  box-shadow: var(--shadow-dark), 0 0 20px rgba(0, 0, 0, 0.3);\n  z-index: 1000;\n  animation: slideDown 0.2s ease;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.notification-dropdown-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  border-bottom: 1px solid var(--border-gray);\n}\n\n.notification-dropdown-header h3 {\n  margin: 0;\n  font-size: 1.1rem;\n  color: var(--text-white);\n  font-weight: 600;\n}\n\n.mark-all-read-btn {\n  background: transparent;\n  border: 1px solid var(--primary-red);\n  color: var(--primary-red);\n  padding: 0.4rem 0.8rem;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 500;\n}\n\n.mark-all-read-btn:hover {\n  background: var(--primary-red);\n  color: var(--text-white);\n}\n\n.notification-list {\n  max-height: 400px;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: var(--border-gray) var(--bg-gray);\n}\n\n.notification-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.notification-list::-webkit-scrollbar-track {\n  background: var(--bg-gray);\n}\n\n.notification-list::-webkit-scrollbar-thumb {\n  background: var(--border-gray);\n  border-radius: 3px;\n}\n\n.notification-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid var(--border-gray);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n.notification-item:last-child {\n  border-bottom: none;\n}\n\n.notification-item:hover {\n  background: var(--bg-gray);\n}\n\n.notification-item.unread {\n  background: var(--bg-gray-light);\n  border-left: 3px solid var(--primary-red);\n}\n\n.notification-item--action-required {\n  border-left: 3px solid #f59e0b;\n  background: rgba(245, 158, 11, 0.07);\n}\n\n.notification-item--action-required.unread {\n  border-left: 3px solid #f59e0b;\n}\n\n.notification-dropdown-action-badge {\n  display: inline-block;\n  font-size: 0.65rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: #fbbf24;\n  margin-bottom: 0.25rem;\n}\n\n.notification-icon {\n  font-size: 1.5rem;\n  flex-shrink: 0;\n  margin-top: 0.2rem;\n}\n\n.notification-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.notification-title {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--text-white);\n  margin-bottom: 0.25rem;\n}\n\n.notification-message {\n  font-size: 0.85rem;\n  color: var(--text-gray);\n  line-height: 1.4;\n  margin-bottom: 0.25rem;\n}\n\n.notification-time {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n}\n\n.unread-indicator {\n  width: 8px;\n  height: 8px;\n  background: var(--primary-red);\n  border-radius: 50%;\n  flex-shrink: 0;\n  margin-top: 0.5rem;\n  box-shadow: var(--shadow-red);\n}\n\n.no-notifications {\n  padding: 3rem 2rem;\n  text-align: center;\n}\n\n.no-notif-icon {\n  font-size: 3rem;\n  display: block;\n  margin-bottom: 1rem;\n  opacity: 0.5;\n}\n\n.no-notifications p {\n  color: var(--text-gray);\n  font-size: 0.9rem;\n}\n\n.notification-dropdown-footer {\n  padding: 0.75rem 1rem;\n  border-top: 1px solid var(--border-gray);\n  text-align: center;\n}\n\n.view-all-btn {\n  background: transparent;\n  border: none;\n  color: var(--primary-red);\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.view-all-btn:hover {\n  background: var(--bg-gray);\n}\n\n/* ==================== NOTIFICATIONS PAGE ==================== */\n.notifications-page {\n  padding: 2rem;\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.notifications-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.notifications-header h1 {\n  color: var(--text-white);\n  font-size: 2rem;\n  font-weight: 700;\n  margin: 0;\n}\n\n.notifications-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  align-items: center;\n}\n\n.clear-all-btn {\n  border-color: var(--text-muted);\n  color: var(--text-gray);\n}\n\n.clear-all-btn:hover {\n  border-color: var(--text-white);\n  color: var(--text-white);\n}\n\n.notifications-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 2rem;\n  border-bottom: 2px solid var(--border-gray);\n  padding-bottom: 0.5rem;\n}\n\n.filter-btn {\n  background: transparent;\n  border: none;\n  color: var(--text-gray);\n  padding: 0.75rem 1rem;\n  font-size: 0.95rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border-bottom: 3px solid transparent;\n  margin-bottom: -0.5rem;\n  white-space: nowrap;\n}\n\n.filter-btn:hover {\n  color: var(--text-white);\n}\n\n.filter-btn.active {\n  color: var(--text-white);\n  border-bottom-color: var(--primary-red);\n}\n\n.notifications-content {\n  min-height: 400px;\n}\n\n.notifications-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n}\n\n.no-notifications-page {\n  text-align: center;\n  padding: 4rem 2rem;\n}\n\n.no-notifications-page .no-notif-icon {\n  font-size: 4rem;\n  margin-bottom: 1.5rem;\n}\n\n.no-notifications-page h2 {\n  color: var(--text-white);\n  margin-bottom: 1rem;\n  font-size: 1.5rem;\n}\n\n.no-notifications-page p {\n  color: var(--text-gray);\n  max-width: 500px;\n  margin: 0 auto;\n  line-height: 1.6;\n}\n\n.notifications-list-page {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.notification-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  background: var(--bg-card);\n  border: 1px solid var(--border-gray);\n  border-radius: 12px;\n  padding: 1.5rem;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.notification-card.unread {\n  border-left: 4px solid var(--primary-red);\n  background: var(--bg-gray-light);\n}\n\n.notification-card--action-required {\n  border-left: 4px solid #f59e0b;\n  border-color: rgba(245, 158, 11, 0.4);\n  background: rgba(245, 158, 11, 0.06);\n}\n\n.notification-card--action-required.unread {\n  border-left: 4px solid #f59e0b;\n}\n\n.notification-action-required-badge {\n  display: inline-block;\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #fbbf24;\n  background: rgba(245, 158, 11, 0.15);\n  padding: 0.2rem 0.5rem;\n  border-radius: 4px;\n  margin-bottom: 0.5rem;\n}\n\n.notification-stale-panel {\n  padding: 0.5rem 0 1rem;\n}\n\n.notification-stale-title {\n  margin: 0 0 0.75rem;\n  font-size: 1.15rem;\n  color: var(--text-white);\n}\n\n.notification-stale-body {\n  margin: 0;\n  color: var(--text-gray);\n  line-height: 1.55;\n}\n\n.notification-stale-actions {\n  display: flex;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  margin-top: 1.25rem;\n}\n\n.notification-card:hover {\n  border-color: var(--border-red);\n  box-shadow: var(--shadow-red);\n  transform: translateX(5px);\n}\n\n.notification-card-icon {\n  font-size: 2rem;\n  flex-shrink: 0;\n}\n\n.notification-card-content {\n  flex: 1;\n  min-width: 0;\n  cursor: pointer;\n}\n\n.notification-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 1rem;\n  margin-bottom: 0.5rem;\n}\n\n.notification-card-title {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--text-white);\n  margin: 0;\n}\n\n.notification-card-time {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.notification-card-message {\n  color: var(--text-gray);\n  line-height: 1.6;\n  margin: 0 0 0.5rem 0;\n}\n\n.notification-card-sender {\n  color: var(--text-muted);\n  font-size: 0.9rem;\n  margin: 0;\n  font-style: italic;\n}\n\n.notification-card-actions {\n  display: flex;\n  gap: 0.5rem;\n  flex-shrink: 0;\n}\n\n.notification-action-btn {\n  background: var(--bg-gray);\n  border: 1px solid var(--border-gray);\n  color: var(--text-white);\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 1.2rem;\n}\n\n.notification-action-btn:hover {\n  background: var(--primary-red);\n  border-color: var(--primary-red);\n}\n\n.notification-action-btn.delete:hover {\n  background: #ef4444;\n  border-color: #ef4444;\n}\n\n/* Artist left bar: formatted intro + show list */\n.notification-artist-left-bar-intro {\n  margin: 0 0 0.5rem 0;\n  color: var(--text-gray);\n  line-height: 1.5;\n  font-size: inherit;\n}\n\n.notification-artist-left-bar-list {\n  max-height: 180px;\n  overflow-y: auto;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 8px;\n  padding: 0.4rem;\n  margin-top: 0.35rem;\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.notification-artist-left-bar-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.25rem;\n  padding: 0.5rem 0.6rem;\n  border-radius: 6px;\n  margin-bottom: 0.2rem;\n  font-size: 0.9rem;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.notification-artist-left-bar-item:last-child {\n  margin-bottom: 0;\n}\n\n.notification-artist-left-bar-item:hover {\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.notification-artist-left-bar-item strong {\n  font-weight: 600;\n  color: var(--text-white, #fff);\n}\n\n.notification-artist-left-bar-time {\n  font-size: 0.85rem;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n/* Dropdown: slightly smaller list for compact view */\n.notification-message .notification-artist-left-bar-list {\n  max-height: 120px;\n}\n\n/* ==================== MESSAGES PAGE ==================== */\n/* Wrapper to isolate messages page styling from other pages */\n.messages-page-wrapper {\n  position: fixed;\n  top: 0;\n  left: 280px;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n}\n\n@media (max-width: 768px) {\n  .messages-page-wrapper {\n    left: 0;\n    top: 64px;\n    bottom: 0;\n  }\n}\n\n.messages-page {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  padding-top: 0.5rem; /* prevent header from being clipped at top */\n}\n\n.messages-container {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  background: var(--bg-dark);\n  overflow: hidden;\n}\n\n.messages-sidebar {\n  width: 350px;\n  border-right: 1px solid var(--border-gray);\n  display: flex;\n  flex-direction: column;\n  background: var(--bg-card);\n  min-width: 0;\n  overflow: hidden;\n}\n\n.messages-sidebar-header {\n  padding: 1.5rem;\n  border-bottom: 1px solid var(--border-gray);\n}\n\n.messages-sidebar-header h2 {\n  margin: 0;\n  color: var(--text-white);\n  font-size: 1.5rem;\n  font-weight: 700;\n}\n\n.conversation-list {\n  flex: 1;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: var(--border-gray) var(--bg-gray);\n}\n\n.conversation-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.conversation-list::-webkit-scrollbar-track {\n  background: var(--bg-gray);\n}\n\n.conversation-list::-webkit-scrollbar-thumb {\n  background: var(--border-gray);\n  border-radius: 3px;\n}\n\n.conversation-list-loading,\n.no-conversations {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  text-align: center;\n}\n\n.no-conv-icon {\n  font-size: 3rem;\n  display: block;\n  margin-bottom: 1rem;\n  opacity: 0.5;\n}\n\n.no-conversations h3 {\n  color: var(--text-white);\n  margin-bottom: 0.5rem;\n}\n\n.no-conversations p {\n  color: var(--text-gray);\n  font-size: 0.9rem;\n}\n\n.conversation-item {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem 1.5rem;\n  border-bottom: 1px solid var(--border-gray);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.conversation-item:hover {\n  background: var(--bg-gray);\n}\n\n.conversation-item.selected {\n  background: var(--bg-gray-light);\n  border-left: 3px solid var(--primary-red);\n}\n\n.conversation-item.unread {\n  background: var(--bg-gray-light);\n}\n\n.conversation-item.pinned {\n  border-left: 2px solid var(--primary-red);\n}\n\n.conversation-item.dragging {\n  opacity: 0.6;\n  background: var(--bg-gray);\n}\n\n.conversation-drag-handle {\n  cursor: grab;\n  padding: 0.25rem 0.5rem;\n  margin-right: 0.25rem;\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n  display: flex;\n  align-items: center;\n  opacity: 0.6;\n  border-radius: 4px;\n}\n\n.conversation-drag-handle:hover {\n  opacity: 1;\n  background: var(--bg-gray);\n}\n\n.conversation-drag-handle:active {\n  cursor: grabbing;\n}\n\n.conversation-avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: var(--primary-red);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-white);\n  font-weight: 700;\n  font-size: 1.2rem;\n  flex-shrink: 0;\n}\n\n.group-avatar-icon {\n  width: 24px;\n  height: 24px;\n  color: #ffffff;\n}\n\n.conversation-details {\n  flex: 1;\n  min-width: 0;\n}\n\n.conversation-header-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.25rem;\n}\n\n.conversation-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.conversation-pin-btn {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0.25rem;\n  font-size: 0.9rem;\n  opacity: 0.5;\n  transition: opacity 0.2s ease;\n}\n\n.conversation-pin-btn:hover {\n  opacity: 0.9;\n}\n\n.conversation-pin-btn.pinned {\n  opacity: 1;\n}\n\n.conversation-name {\n  font-weight: 600;\n  color: var(--text-white);\n  font-size: 1rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.conversation-time {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n  white-space: nowrap;\n  flex-shrink: 0;\n  margin-left: 0.5rem;\n}\n\n.conversation-message-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.conversation-last-message {\n  font-size: 0.85rem;\n  color: var(--text-gray);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1;\n}\n\n.conversation-unread-badge {\n  background: var(--primary-red);\n  color: var(--text-white);\n  border-radius: 10px;\n  padding: 2px 8px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  min-width: 20px;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n/* Messages Main */\n.messages-main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background: var(--bg-dark);\n  min-width: 0;\n  overflow: hidden;\n}\n\n.chat-window-empty {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 2rem;\n}\n\n.empty-icon {\n  font-size: 4rem;\n  display: block;\n  margin-bottom: 1rem;\n  opacity: 0.3;\n}\n\n.empty-state h2 {\n  color: var(--text-white);\n  margin-bottom: 0.5rem;\n}\n\n.empty-state p {\n  color: var(--text-gray);\n}\n\n/* Chat Window */\n.chat-window {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.chat-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem 1.5rem;\n  border-bottom: 1px solid var(--border-gray);\n  background: var(--bg-card);\n}\n\n.chat-back-btn {\n  flex-shrink: 0;\n  border: 1px solid var(--border-gray);\n  background: var(--bg-dark);\n  color: var(--text-white);\n  padding: 0.45rem 0.75rem;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s ease, border-color 0.2s ease;\n}\n\n.chat-back-btn:hover {\n  background: var(--bg-gray);\n  border-color: var(--primary-red);\n  color: var(--primary-red);\n}\n\n.chat-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.chat-archive-btn {\n  border: 1px solid var(--border-gray);\n  background: var(--bg-dark);\n  color: var(--text-white);\n  min-width: 36px;\n  height: 36px;\n  padding: 0 0.6rem;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-weight: 600;\n}\n\n.chat-archive-btn:hover {\n  background: var(--border-gray);\n}\n\n.chat-archive-btn:active {\n  transform: translateY(1px);\n}\n\n.chat-header-info {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex: 1;\n  min-width: 0;\n}\n\n.chat-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: var(--primary-red);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-white);\n  font-weight: 700;\n  font-size: 1.1rem;\n}\n\n.chat-name {\n  color: var(--text-white);\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.chat-name-row {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.chat-title-edit-btn {\n  border: none;\n  background: transparent;\n  color: var(--text-muted);\n  cursor: pointer;\n  font-size: 0.9rem;\n  padding: 0.2rem;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.chat-title-edit-btn:hover {\n  color: var(--text-white);\n  background: var(--bg-gray);\n}\n\n.chat-name-edit-row {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.chat-name-input {\n  min-width: 220px;\n  max-width: 360px;\n  padding: 0.4rem 0.6rem;\n  border-radius: 8px;\n  border: 1px solid var(--border-gray);\n  background: var(--bg-gray);\n  color: var(--text-white);\n  font-size: 0.95rem;\n}\n\n.chat-name-input:focus {\n  outline: none;\n  border-color: var(--primary-red);\n}\n\n.chat-title-action-btn {\n  border: 1px solid var(--primary-red);\n  background: var(--primary-red);\n  color: var(--text-white);\n  border-radius: 8px;\n  height: 32px;\n  padding: 0 0.65rem;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 0.8rem;\n}\n\n.chat-title-action-btn.secondary {\n  background: transparent;\n  border-color: var(--border-gray);\n  color: var(--text-gray);\n}\n\n.chat-group-members {\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n  opacity: 0.85;\n  margin-top: 0.15rem;\n  line-height: 1.3;\n}\n\n.typing-indicator-text {\n  color: var(--primary-red);\n  font-size: 0.85rem;\n  font-style: italic;\n}\n\n.chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  scrollbar-width: thin;\n  scrollbar-color: var(--border-gray) var(--bg-gray);\n}\n\n.chat-messages-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  gap: 1rem;\n  padding: 2rem;\n}\n\n.chat-messages-loading .spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid var(--border-gray);\n  border-top: 4px solid var(--primary-red);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.chat-messages-loading p {\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.chat-messages::-webkit-scrollbar {\n  width: 8px;\n}\n\n.chat-messages::-webkit-scrollbar-track {\n  background: var(--bg-gray);\n}\n\n.chat-messages::-webkit-scrollbar-thumb {\n  background: var(--border-gray);\n  border-radius: 4px;\n}\n\n.no-messages {\n  text-align: center;\n  padding: 2rem;\n  color: var(--text-gray);\n}\n\n/* Message Bubbles */\n.message-bubble-container {\n  display: flex;\n  flex-direction: column;\n  max-width: 70%;\n}\n\n.message-bubble-container.own {\n  align-self: flex-end;\n  align-items: flex-end;\n}\n\n.message-bubble-container.other {\n  align-self: flex-start;\n  align-items: flex-start;\n}\n\n.message-sender-name {\n  font-size: 0.8rem;\n  color: var(--text-muted);\n  margin-bottom: 0.25rem;\n  padding: 0 0.5rem;\n}\n\n.message-bubble {\n  padding: 0.75rem 1rem;\n  border-radius: 16px;\n  word-wrap: break-word;\n  animation: messageSlideIn 0.2s ease;\n}\n\n@keyframes messageSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.message-bubble-container.own .message-bubble {\n  background: var(--primary-red);\n  color: var(--text-white);\n  border-bottom-right-radius: 4px;\n}\n\n.message-bubble-container.other .message-bubble {\n  background: var(--bg-gray);\n  color: var(--text-white);\n  border-bottom-left-radius: 4px;\n}\n\n.message-text {\n  font-size: 0.95rem;\n  line-height: 1.5;\n  margin-bottom: 0.25rem;\n}\n\n.message-edited {\n  font-size: 0.75rem;\n  opacity: 0.7;\n  font-style: italic;\n}\n\n.message-time {\n  font-size: 0.75rem;\n  opacity: 0.7;\n  text-align: right;\n}\n\n/* Chat Input */\n.chat-input-container {\n  display: flex;\n  gap: 0.75rem;\n  padding: 1rem 1.5rem;\n  border-top: 1px solid var(--border-gray);\n  background: var(--bg-card);\n}\n\n.chat-input {\n  flex: 1;\n  padding: 0.75rem 1rem;\n  background: var(--bg-gray);\n  border: 2px solid var(--border-gray);\n  border-radius: 24px;\n  color: var(--text-white);\n  font-size: 0.95rem;\n  resize: none;\n  max-height: 120px;\n  font-family: inherit;\n  transition: all 0.3s ease;\n}\n\n.chat-input:focus {\n  outline: none;\n  border-color: var(--primary-red);\n  background: var(--bg-gray-light);\n}\n\n.chat-input::placeholder {\n  color: var(--text-muted);\n}\n\n.chat-send-btn {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: var(--primary-red);\n  border: none;\n  color: var(--text-white);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  flex-shrink: 0;\n}\n\n.chat-send-btn:hover:not(:disabled) {\n  background: var(--primary-red-dark);\n  transform: scale(1.05);\n  box-shadow: var(--shadow-red);\n}\n\n.chat-send-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.send-icon {\n  font-size: 1.2rem;\n  display: block;\n}\n\n/* Responsive Styles */\n@media (max-width: 768px) {\n  /* Mobile Header Updates */\n  .mobile-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .mobile-header-left {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n  }\n\n  .mobile-header-right {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n  }\n\n  .messages-container {\n    position: relative;\n  }\n\n  /* Inbox: full-width conversation list only */\n  .messages-container--mobile-inbox .messages-sidebar {\n    position: relative;\n    width: 100%;\n    max-width: 100%;\n    flex: 1;\n    min-height: 0;\n    transform: none;\n    border-right: none;\n  }\n\n  .messages-container--mobile-inbox .messages-main {\n    display: none;\n  }\n\n  /* Thread: full-width chat only */\n  .messages-container--mobile-thread .messages-sidebar {\n    display: none;\n  }\n\n  .messages-container--mobile-thread .messages-main {\n    display: flex;\n    flex: 1;\n    width: 100%;\n    min-width: 0;\n    min-height: 0;\n    overflow: hidden;\n  }\n\n  .notification-dropdown {\n    width: 340px;\n  }\n\n  .notifications-page {\n    padding: 1rem;\n  }\n\n  .notifications-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n\n  .notifications-filters {\n    gap: 0.35rem;\n  }\n\n  .filter-btn {\n    padding: 0.6rem 0.75rem;\n    font-size: 0.85rem;\n  }\n\n  .notification-card {\n    padding: 1rem;\n  }\n\n  .message-bubble-container {\n    max-width: 85%;\n  }\n}\n\n@media (max-width: 480px) {\n  /*\n   * Keep the panel under the bell: width must stay bounded relative to the narrow\n   * .notification-bell-container — nearly full-viewport width + right offset pinned the\n   * dropdown’s right edge to the bell but stretched the sheet far left across the screen.\n   */\n  .notification-dropdown {\n    width: min(340px, calc(100vw - 1.5rem));\n    max-width: calc(100vw - 1rem);\n    right: 0;\n    left: auto;\n  }\n\n  .conversation-item {\n    padding: 0.75rem 1rem;\n  }\n\n  .chat-header {\n    padding: 0.75rem 1rem;\n  }\n\n  .chat-messages {\n    padding: 1rem;\n  }\n\n  .chat-input-container {\n    padding: 0.75rem 1rem;\n  }\n\n  .message-bubble-container {\n    max-width: 90%;\n  }\n}\n\n/* ==================== NEW MESSAGE DROPDOWN ==================== */\n@keyframes newMessageDropdownIn {\n  from {\n    opacity: 0;\n    transform: translate(-50%, -50%) translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translate(-50%, -50%) translateY(0);\n  }\n}\n\n.new-message-dropdown {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 500px;\n  max-width: 90vw;\n  max-height: 80vh;\n  background: var(--bg-card);\n  border: 1px solid var(--border-gray);\n  border-radius: 12px;\n  box-shadow: var(--shadow-dark), 0 0 20px rgba(0, 0, 0, 0.3);\n  z-index: 2000;\n  display: flex;\n  flex-direction: column;\n  animation: newMessageDropdownIn 0.2s ease;\n}\n\n.new-message-dropdown-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  border-bottom: 1px solid var(--border-gray);\n}\n\n.new-message-dropdown-header h3 {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.new-message-dropdown-close {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: var(--text-secondary);\n  cursor: pointer;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.new-message-dropdown-close:hover {\n  background: var(--bg-gray);\n  color: var(--text-primary);\n}\n\n.new-message-dropdown-search {\n  padding: 1rem;\n  border-bottom: 1px solid var(--border-gray);\n}\n\n.new-message-search-input {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid var(--border-gray);\n  border-radius: 8px;\n  font-size: 0.95rem;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n}\n\n.new-message-search-input:focus {\n  outline: none;\n  border-color: var(--primary-red);\n  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);\n}\n\n.new-message-dropdown-list {\n  flex: 1;\n  overflow-y: auto;\n  max-height: calc(80vh - 150px);\n  padding: 0.5rem;\n}\n\n.new-message-recipient-item {\n  display: flex;\n  align-items: center;\n  padding: 0.75rem;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  gap: 0.75rem;\n}\n\n.new-message-recipient-item:hover {\n  background: var(--bg-gray);\n}\n\n.recipient-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: var(--primary-red);\n  color: var(--text-white);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 1rem;\n  flex-shrink: 0;\n}\n\n.recipient-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.recipient-name-row {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.25rem;\n}\n\n.recipient-name {\n  font-weight: 600;\n  color: var(--text-primary);\n  font-size: 0.95rem;\n}\n\n.recipient-role-badge {\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.recipient-role-badge.owner {\n  background: rgba(59, 130, 246, 0.1);\n  color: #3b82f6;\n}\n\n.recipient-role-badge.admin {\n  background: rgba(147, 51, 234, 0.1);\n  color: #9333ea;\n}\n\n.recipient-role-badge.artist {\n  background: rgba(234, 179, 8, 0.1);\n  color: #eab308;\n}\n\n.recipient-source-badge {\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 0.65rem;\n  font-weight: 600;\n  max-width: 140px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.recipient-source-badge.band-member {\n  background: rgba(16, 185, 129, 0.15);\n  color: #10b981;\n}\n\n.recipient-source-badge.bar-owner {\n  background: rgba(59, 130, 246, 0.1);\n  color: #3b82f6;\n}\n\n.recipient-source-badge.bar-admin {\n  background: rgba(147, 51, 234, 0.1);\n  color: #9333ea;\n}\n\n.recipient-source-badge.artist {\n  background: rgba(234, 179, 8, 0.1);\n  color: #eab308;\n}\n\n.new-message-selected {\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid var(--border-gray);\n}\n\n.selected-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.selected-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.25rem 0.5rem;\n  background: var(--bg-gray);\n  border-radius: 16px;\n  font-size: 0.85rem;\n}\n\n.selected-chip-remove {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0 0.125rem;\n  font-size: 1rem;\n  line-height: 1;\n  color: var(--text-secondary);\n  border-radius: 4px;\n}\n\n.selected-chip-remove:hover {\n  color: var(--primary-red);\n}\n\n.new-message-group-name {\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  border: 1px solid var(--border-gray);\n  border-radius: 6px;\n  background: var(--bg-input);\n  color: var(--text-primary);\n  font-size: 0.9rem;\n}\n\n.new-message-group-name:focus {\n  outline: none;\n  border-color: var(--primary-red);\n}\n\n.new-message-dropdown-footer {\n  padding: 1rem;\n  border-top: 1px solid var(--border-gray);\n}\n\n/* Shown only on mobile — see modals-mobile.css; hidden on desktop (header × is enough). */\n.new-message-cancel-btn {\n  display: none;\n}\n\n.new-message-start-btn {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  background: var(--primary-red);\n  color: var(--text-white);\n  border: none;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.new-message-start-btn:hover:not(:disabled) {\n  background: var(--primary-red-dark);\n}\n\n.new-message-start-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.recipient-check {\n  color: var(--primary-red);\n  font-weight: bold;\n  font-size: 1rem;\n}\n\n.new-message-recipient-item.selected {\n  background: rgba(220, 38, 38, 0.08);\n  border-left: 3px solid var(--primary-red);\n}\n\n/* ==================== BAR CONTACTS DROPDOWN ==================== */\n.bar-contacts-dropdown {\n  width: 350px;\n  max-width: 90vw;\n  max-height: 400px;\n  background: var(--bg-card);\n  border: 1px solid var(--border-gray);\n  border-radius: 12px;\n  box-shadow: var(--shadow-dark), 0 0 20px rgba(0, 0, 0, 0.3);\n  display: flex;\n  flex-direction: column;\n  animation: slideDown 0.2s ease;\n}\n\n.bar-contacts-dropdown .new-message-dropdown-list {\n  max-height: calc(400px - 60px);\n}\n\n.recipient-email {\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.recipient-relationship {\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n  margin-top: 0.15rem;\n}\n\n.recipient-relationship .recipient-source-badge {\n  font-size: 0.8rem;\n}\n\n.recipient-relationships {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0 0.25rem;\n  align-items: center;\n}\n\n.new-message-loading,\n.new-message-error,\n.new-message-empty {\n  padding: 2rem;\n  text-align: center;\n  color: var(--text-secondary);\n}\n\n.new-message-retry-btn {\n  margin-top: 1rem;\n  padding: 0.5rem 1rem;\n  background: var(--primary-red);\n  color: var(--text-white);\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.2s ease;\n}\n\n.new-message-retry-btn:hover {\n  background: var(--primary-red-dark);\n}\n\n/* ==================== CONVERSATION LIST HEADER ==================== */\n.conversation-list-header {\n  padding: 1rem;\n  border-bottom: 1px solid var(--border-gray);\n  background: var(--bg-card);\n}\n\n.conversation-list-header-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.75rem;\n}\n\n.conversation-list-header-top h2 {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.new-message-btn {\n  padding: 0.5rem 1rem;\n  background: var(--primary-red);\n  color: var(--text-white);\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 0.9rem;\n  transition: all 0.2s ease;\n}\n\n.new-message-btn:hover {\n  background: var(--primary-red-dark);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.3);\n}\n\n.conversation-list-search {\n  width: 100%;\n}\n\n.conversation-search-input {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid var(--border-gray);\n  border-radius: 8px;\n  font-size: 0.9rem;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n}\n\n.conversation-search-input:focus {\n  outline: none;\n  border-color: var(--primary-red);\n  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);\n}\n\n/* ==================== READ RECEIPTS ==================== */\n.message-meta {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-top: 0.25rem;\n}\n\n.message-read-receipt {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n}\n\n/* iOS-style text labels: Delivered / Read */\n.read-receipt-text {\n  font-size: 0.75rem;\n  line-height: 1;\n  font-weight: 500;\n}\n\n.read-receipt-text.read-receipt-delivered {\n  color: var(--text-secondary);\n}\n\n.read-receipt-text.read-receipt-read {\n  color: var(--text-secondary);\n}\n\n/* Group: \"Read by X of Y\" */\n.message-read-receipt-group .read-receipt-text {\n  font-size: 0.7rem;\n  color: var(--text-secondary);\n}\n\n.read-time-tooltip {\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  margin-bottom: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  background: rgba(0, 0, 0, 0.9);\n  color: var(--text-white);\n  border-radius: 6px;\n  font-size: 0.75rem;\n  white-space: nowrap;\n  pointer-events: none;\n  z-index: 10;\n}\n\n.read-time-tooltip::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 5px solid transparent;\n  border-top-color: rgba(0, 0, 0, 0.9);\n}\n\n/* ==================== MESSAGE ARTIST BUTTON ==================== */\n.artist-profile-message-btn {\n  border: none;\n  background: rgba(255, 255, 255, 0.05);\n  color: rgba(255, 255, 255, 0.75);\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.35rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin-right: 0.5rem;\n}\n\n.artist-profile-message-btn:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.12);\n  color: var(--primary-red);\n}\n\n.artist-profile-message-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
